<template>
  <div class="live_gift">
    <Popup v-model="showPop" @close="onClose" round position="bottom" class="gift_sheet">
      <div class="gift_wrap" v-if="lwList.length">
        <div class="lw_div" v-if="tab_active==0">
          <div
            class="lw_item"
            :class="{is_check:lwCheck==item.code}"
            v-for="(item,index) in lwList"
            @click="lwCheck==item.code?giveTo(item):lwCheck=item.code"
            :key="index"
          >
            <img :src="item.icon" />
            <div
              class="lw_title"
            >{{lwCheck==item.code?(item.amount==0?'免费':item.amount+'金豆'):item.name}}</div>
            <div class="lw_money">{{item.amount==0?'免费':item.amount+'金豆'}}</div>
            <div class="lw_give" v-if="lwCheck==item.code">送给他</div>
          </div>
        </div>
      </div>
      <div class="gift_bottom">
        <div class="gifttab_nav">
          <div class="gift_nav_item" :class="{is_active:tab_active==0}">礼物</div>
        </div>
        <div class="gift_bottom_right" @click="goToBalance">
          <div class="remain_btn">
            余额
            <img src="../../../assets/img/live/mydou.png" />
            {{BanlanceCount}}
            <i class="icon iconfont icon-xiala"></i>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup, Dialog } from "vant";
import { mapActions, mapMutations, mapGetters } from "vuex";
import gql from 'graphql-tag';
export default {
  name: "live-gift",
  props: ['show'],
  data() {
    return {
      showPop: false,
      tab_active: 0,
      banlance: 0,
      lwCheck: "",
      lwList:[],
      Member:null,
    };
  },
  watch: {
    show(val, oldVal) { 
      this.showPop = val;
      if(this.showPop){
        this.open();
      }
    },
  },
  components: { Popup },
  created(){
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userInfo: "getUserInfo",
    }),
    query() {
      return this.$router.history.current.query;
    },
    // 人数超过w换算
    BanlanceCount() {
      //过万处理
      console.log(this.banlance);
      let value = this.banlance;
      var num=0;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "W";
      } else if (value <= 9999 && value > -9999) {
        num = value;
      } else if (value < -9999) {
        //小于-9999显示-x.xx万
        num = -(Math.floor(Math.abs(value) / 1000) / 10) + "w";
      }
      return num;
    },
  },
  methods: {
    ...mapActions({
      getBanlance: "act/getBanlance",
      giftTo: "act/giftTo",
      likeTo: "likeTo",
      LinkToMyAccount:'linkTo/LinkToMyAccount',
      LinkToMyService:'linkTo/LinkToMyService'
    }),
    async init(){
      this.getAllGift();
      this.Member = await this.$Myapollo.getUserInfo(this);
    },
    getAllGift(){
      let giftGql =  gql`query getAllGifts{
              getAllGifts{
                amount
                code
                createAt
                icon
                metadata
                name
                showIndex
              }
            }`
      this.$apollo.addSmartQuery('getAllGifts', {
        query:giftGql, 
        result(res) {
          console.log(res,'res');
          if(res.data.getAllGifts){
            let data = JSON.parse(JSON.stringify(res.data.getAllGifts));
            this.lwList = data.sort(this.compare("showIndex"));
          }
        },// 错误处理
        error(error) {
            console.error(error,'error错误处理')
        }
      })
    },
    compare(key) {
      return (obj1, obj2) => {
        let value1 = obj1[key];
        let value2 = obj2[key];
        if (value1 > value2) {
          return 1;
        } else if (value1 < value2) {
          return -1;
        } else {
          return 0;
        }
      };
    },
    async open() {
      let res= await this.getBanlance(this.userInfo.id);
      this.banlance = res
    },
    goToBalance(){
      this.LinkToMyAccount('expend')
    },
    yebuzu() {
        Dialog.confirm({
          title: '余额不足',
          message: '您的金豆余额不足了，请前往\n联系客服',
          className:'dialog_yue',
          zIndex:10000,
          confirmButtonText:'前往',
          confirmButtonOpenType:'contact',
        })
        .then(() => {
          this.LinkToMyService();
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    async giveTo(data) {
      if (this.banlance >= data.amount) {
        // this.$emit('sendgift',data); // 送礼动画
        let opt = {
          inMemberId: this.Member.inMember.id,
          toType: 0,
          toTypeId: this.query.actId,
          giftCode: this.lwCheck,
          number: 1,
        };
        let res = await this.giftTo(opt);
        if (!res.result) {
          if (res.code == 5) {
            this.yebuzu();
          } else {
            this.$toast.success(res.message);
          }
        }
        let ye = await this.getBanlance(this.userInfo.id);
        if (ye) {
          this.banlance = ye;
        }
      } else {
        console.log('余额不足了')
        this.yebuzu();
      }
    },
    onClose() {
      setTimeout(() => {
        this.$emit("closePop");
      }, 300);
    },
  },
};
</script>


<style scoped lang="scss">
@keyframes doudong {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  to {
    transform: scale(1);
  }
}
.live_gift {
  ::v-deep{
    .van-popup {
      &.gift_sheet {
        z-index:9999!important;
        border-radius: 5px 5px 0px 0px;
        box-shadow:0 0 20px rgba(0,0,0,0.2);
        height: 275px;
        overflow: hidden;
        .gift_wrap {
          width: 100%;
          padding: 18px 10px;
          box-sizing: border-box;
          .lw_div {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .lw_item {
              width: 24%;
              height: 90px;
              box-sizing: border-box;
              text-align: center;
              overflow: hidden;
              border: 1px solid transparent;
              &.is_check {
                border-color: #f85b0f;
                border-radius: 5px;
                position: relative;
                animation: doudong 0.2s;

                .lw_give {
                  position: absolute;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  background: #f85b0f;
                  height: 23px;
                  color: #fff;
                  font-size: 13px;
                }
              }
              img {
                width: 73px;
                height: 47px;
              }
              .lw_title {
                color: #333;
                font-size: 12px;
                line-height: 1;
                margin-bottom: 5px;
              }
              .lw_money {
                color: #999;
                font-size: 10px;
                font-weight: bold;
              }
            }
          }
        }
        .gift_bottom {
          height: 50px;
          box-sizing: border-box;
          border-top: 1px solid #f5f5f5;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          .gifttab_nav {
            display: flex;
            align-items: center;
            height: 100%;
            font-size: 13px;
            .gift_nav_item {
              display: flex;
              align-items: center;
              color: #999;
              height: 100%;
              margin-right: 25px;
              &:last-child {
                margin-right: 0;
              }
              &.is_active {
                color: #333;
                position: relative;
                &::before {
                  content: "";
                  position: absolute;
                  display: block;
                  width: 25px;
                  height: 2px;
                  background-color: #f85b0f;
                  border-radius: 1;
                  left: 50%;
                  transform: translateX(-50%);
                  bottom: 11px;
                }
              }
            }
          }
          .gift_bottom_right {
            display: flex;
            height: 100%;
            align-items: center;
            .remain_btn {
              padding: 0 6px;
              height: 29px;
              box-sizing: border-box;
              color: #666;
              font-size: 11px;
              display: flex;
              border-radius: 5px;
              background: rgba(248, 91, 15, 0.1);
              align-items: center;
              img {
                width: 13px;
                height: 13px;
                display: block;
                margin: 0 5px;
              }
              .icon-xiala {
                color: #999;
                margin-left: 5px;
                font-size: 12px;
                transform: rotate(-90deg);
              }
            }
          }
        }
      }
    } 
    .van-overlay{
      z-index: 9990!important;
    }
  }
  ::v-deep .yue_dialog {
    .van-popup {
      border-radius: 5px;
      width: 280px;
      box-sizing: border-box;
      .van-dialog__header {
        padding-top: 25px;
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
      .van-dialog__message {
        font-size: 15px;
        color: #666;
      }
      .van-hairline--top {
        &::after {
          border-color: #d2d3d5;
          border-top-width: 1px;
        }
      }
      .van-dialog__footer {
        .van-hairline--right {
          &::after {
            border-color: #d2d3d5;
            border-right-width: 1px;
          }
        }
        .van-dialog__button {
          .dialog-index--van-dialog__confirm {
            color: #f85b0f !important;
          }
        }
      }
    }
  }
}
</style>
